module.exports = __webpack_public_path__ + "img/employee-salary-setting.98a3dafd.svg";